(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ems-responsive-slideshow"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ems-slideshow')) {
  customElements.define('ems-slideshow', class extends HTMLElement {
    connectedCallback() {
      this.track=this.querySelector('.ems-showcase__track');
      this.slides=[...this.querySelectorAll('.ems-showcase__slide')];
      this.dots=[...this.querySelectorAll('[data-slide]')];
      this.index=0;
      this.abort=new AbortController();
      const options={signal:this.abort.signal};
      this.motion=window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused=this.dataset.autoplay!=='true'||this.motion.matches;
      this.playRequested=false;
      this.hover=false;
      this.focused=false;
      this.querySelector('.ems-showcase__controls').hidden=this.slides.length<2;
      this.querySelectorAll('[data-direction]').forEach(button=>button.addEventListener('click',()=>{this.go(this.index+Number(button.dataset.direction));this.schedule();},options));
      this.dots.forEach((button,index)=>button.addEventListener('click',()=>{this.go(index);this.schedule();},options));
      this.pauseButton=this.querySelector('[data-pause]');
      this.pauseButton?.addEventListener('click',()=>{this.paused=!this.paused;this.playRequested=!this.paused;this.updatePause();this.schedule();},options);
      this.track.addEventListener('scroll',()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>{const left=this.track.getBoundingClientRect().left;this.index=this.slides.reduce((best,slide,index)=>Math.abs(slide.getBoundingClientRect().left-left)<Math.abs(this.slides[best].getBoundingClientRect().left-left)?index:best,0);this.updateDots();});},options);
      this.track.addEventListener('pointerdown',()=>{this.touching=true;this.schedule();},options);
      window.addEventListener('pointerup',()=>{this.touching=false;this.schedule();},options);
      window.addEventListener('pointercancel',()=>{this.touching=false;this.schedule();},options);
      this.track.addEventListener('keydown',event=>{if(event.target!==this.track)return;if(['ArrowLeft','ArrowRight'].includes(event.key)){event.preventDefault();this.go(this.index+(event.key==='ArrowRight'?1:-1));this.schedule();}},options);
      this.addEventListener('mouseenter',()=>{this.hover=true;this.playRequested=false;this.schedule();},options);
      this.addEventListener('mouseleave',()=>{this.hover=false;this.schedule();},options);
      this.addEventListener('focusin',()=>{this.focused=true;this.playRequested=false;this.schedule();},options);
      this.addEventListener('focusout',event=>{this.focused=this.contains(event.relatedTarget);this.schedule();},options);
      document.addEventListener('visibilitychange',()=>this.schedule(),options);
      this.motion.addEventListener('change',()=>{if(this.motion.matches)this.stopAuto();},options);
      this.resize=new ResizeObserver(()=>this.go(this.index,false));this.resize.observe(this.track);
      this.updateDots();this.updatePause();this.schedule();
    }
    disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();clearTimeout(this.timer);cancelAnimationFrame(this.frame);}
    go(index,animate=true){if(!this.slides.length)return;const wrapped=index<0||index>=this.slides.length;this.index=((index%this.slides.length)+this.slides.length)%this.slides.length;const left=this.track.scrollLeft+this.slides[this.index].getBoundingClientRect().left-this.track.getBoundingClientRect().left;this.track.scrollTo({left,behavior:animate&&!wrapped&&!this.motion.matches?'smooth':'instant'});this.updateDots();}
    updateDots(){this.dots.forEach((dot,index)=>dot.setAttribute('aria-current',String(index===this.index)));}
    updatePause(){if(!this.pauseButton)return;this.pauseButton.setAttribute('aria-label',this.paused?this.pauseButton.dataset.playLabel:this.pauseButton.dataset.pauseLabel);this.pauseButton.firstElementChild.textContent=this.paused?'▷':'Ⅱ';}
    stopAuto(){this.paused=true;this.playRequested=false;this.updatePause();this.schedule();}
    schedule(){clearTimeout(this.timer);if(this.paused||this.touching||((this.hover||this.focused)&&!this.playRequested)||document.hidden||this.motion.matches||this.slides.length<2)return;this.timer=setTimeout(()=>{this.go(this.index+1);this.schedule();},Number(this.dataset.speed)||7000);}
  });
}
  } catch(e) { console.error(e); }
})();

})();
